// Microsoft Entra ID (Azure AD) sign-in configuration.
//
// The three values below are NOT secrets — a SPA client ID / tenant ID /
// redirect URI are all visible in the browser's network tab no matter what,
// which is exactly why this app registration was set up as a "Single-Page
// application" with NO client secret (Azure won't even let you add one to
// an SPA redirect URI — the login uses the Authorization Code + PKCE flow
// instead, which doesn't need one).
//
// Values come from environment variables so the same code works locally
// and on Render without editing this file:
//   REACT_APP_MSAL_CLIENT_ID     - "Application (client) ID" from the Azure
//                                   Portal app registration overview page
//   REACT_APP_MSAL_TENANT_ID     - "Directory (tenant) ID" from the same page
//   REACT_APP_MSAL_REDIRECT_URI  - must exactly match one of the "Redirect
//                                   URIs" configured under Authentication ▸
//                                   Single-page application in Azure. Falls
//                                   back to the current origin if not set,
//                                   which is right for local dev.
//
// IMPORTANT (Create React App quirk): REACT_APP_* variables are baked into
// the JS bundle at BUILD time, not read at server runtime. On Render this
// means these three variables must be set on the FRONTEND service itself
// (Environment tab) BEFORE it builds — setting them after deploy and just
// restarting the service does nothing; a fresh build/deploy is required.

export const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || "";
export const MSAL_TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID || "";

export const msalConfig = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    // Single-tenant: only accounts inside this exact organization can sign
    // in (matches "Accounts in this organizational directory only" chosen
    // in the Azure Portal).
    authority: `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage (not sessionStorage) so a refresh — or opening a second
    // tab — doesn't force signing in again.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Scope requested at login. "User.Read" is the standard "who am I" scope —
// we don't need any deeper Microsoft Graph permissions, just proof of who
// signed in. The backend validates the ID/access token itself (see
// server/index.js) rather than trusting anything the frontend claims.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Scope used specifically when asking MSAL for an access token to attach to
// our own backend's API calls. Using the same "User.Read"-style default
// (api://<clientId>/.default is only needed if we'd exposed a custom API
// scope in Azure — we didn't, so the standard Graph-flavored token is fine
// since the backend only checks aud/iss, not what Graph permissions it has).
export const apiTokenRequest = {
  scopes: ["User.Read"],
};
